// from https://github.com/emotion-js/emotion/issues/2193#issuecomment-766173118

import { CreateStyled } from "@emotion/styled";

export const withTransientProps: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith("$")
};
